export const getBlueConicScript = (
  canonicalUrl: string,
  templateName: string,
  edition: string,
  urlEndpoint: string,
) => {
  if (!urlEndpoint) {
    return [];
  }

  const scripts: any[] = [];

  const blueConicEdition = {
    'p329.si.com':
      (canonicalUrl && canonicalUrl.includes('www.si.com'))
      || edition === 'si_swimsuit',
    'p123.fansided.com': edition === '229',
    'p123.mentalfloss.com': edition === 'mentalfloss',
    'p123.theplayerstribune.com': edition === 'theplayertribune',
    [`123p.${urlEndpoint}`]: !['si', 'si_swimsuit', '229', 'mentalfloss', 'theplayertribune'].includes(edition),
  };

  Object.entries(blueConicEdition).forEach(([key, value]) => {
    if (value && templateName !== 'PostPagePrague' && edition !== 'high_school') {
      scripts.push({
        type: 'URL',
        source: `https://${key}/script.js`,
        name: 'BlueConic',
        attributes: null,
        loadingType: 'async',
      });
    }
  });

  return scripts;
};
